module.exports = __webpack_public_path__ + "img/img151_8.20ea8216.png";